import { Contributions } from "@openimis/fe-core";
import React from "react";

const HomePage = (props) => {
  return <Contributions contributionKey="home.HomePage.Container" {...props} />;
};

export default HomePage;
